import React, { useState, useRef } from "react";
import { Tab, Nav, Container, Row, Col, Button, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig.js";
import { v4 as uuidv4 } from "uuid";

export default function ScriptBoxes(props) {

  const [excludeNbInShoppingKeywords, setExcludeNbInShoppingKeywords] = useState(jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "keyword"], props) || {});
  const [youtubeChannelExcluderData, setYoutubeChannelExcluderData] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder"], props) || {});

  const deleteKeyword = (e, kwNum) => {
    e.preventDefault();
    const {[kwNum]: deletedValue, ...remainingKeywords} = excludeNbInShoppingKeywords;
    setExcludeNbInShoppingKeywords(remainingKeywords);
    if (props.onboarding) {
      let newScripts = { ...props.client_account.scripts };
      newScripts["exclude_nb_in_shopping"]["keyword"] = remainingKeywords;
      props.setScripts({ ...newScripts });
    }
  };

  const handleAddKeyword = (e) => {
    e.preventDefault();
    // excludeNbInShoppingKeywords is an object with numeric keys
    const newKey = uuidv4()
    const newKeywords = { ...excludeNbInShoppingKeywords, [newKey]: "" }; // Add a new entry with an empty string or a default value
    setExcludeNbInShoppingKeywords(newKeywords);
  };

  const handleScriptPropertyInput = (e, propertyName, currentData, updateMethod) => {
    e.preventDefault();
    console.log("handleScriptPropertyInput", propertyName, e.target.value);
    const newData = { ...currentData, [propertyName]: e.target.value };
    updateMethod(newData);
  };

  return (
    <>
      {props.scripts.map((script) => {
        return (
          <React.Fragment key={script.name}>
            {script.name == "exclude_nb_in_shopping" ? (
              <Col className="script-box-wide mb-2 px-2">
                <div className="p-3 h-100" style={{ backgroundColor: "#e1e1e1" }}>
                  <div className="mb-2">
                    {props.onboarding ? (
                      <CustomFormCheck
                        id={`scripts_exclude_nb_in_shopping`}
                        sendUncheckedValue
                        checked={jsDig(["isChecked", script.name, "enabled"], props) == "1" ? true : false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        onChange={(e) => {
                          let newScripts = props.client_account.scripts;
                          newScripts[script.name] = newScripts[script.name] || {};
                          newScripts[script.name]["enabled"] = e.target.checked ? "1" : "0";
                          props.setScripts({ ...newScripts });
                          props.setIsChecked({ ...newScripts });
                          props.checkValidation();
                        }}
                      />
                    ) : (
                      <CustomFormCheck
                        id={`scripts_exclude_nb_in_shopping`}
                        name={`[scripts][exclude_nb_in_shopping][enabled]`}
                        sendUncheckedValue
                        defaultChecked={jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "enabled" ], props) == "1" ? true: false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        static
                      />
                    )}
                  </div>
                  <div>
                    <p className="f14 light-primary nunito-regular pb-3">
                      {script.desc}
                    </p>
                  </div>
                  <div>
                    <p className="f14 light-primary nunito-bold pb-1">Please add branded keywords - keywords should only match variations of the company name, no long-tail keywords:</p>
                    <p className="f12 light-primary nunito pb-3"><i>All keywords with more than 0 clicks in the past 30 days will be analyzed</i></p>
                  </div>
                  <div className="d-flex" style={{gap: "12px"}}>
                    <div className="script-list d-flex flex-wrap" style={{columnGap: "12px"}}>
                      {Object.keys(excludeNbInShoppingKeywords).map((kwNum, i) => {
                        return (
                          <div key={i} className="d-flex align-items-center pb-2" style={{gap: "8px"}}>
                            <span className="list-number d-none" style={{minWidth: "22px"}}>{kwNum}.</span>
                            {props.onboarding ? (
                              <Form.Control
                                className="d-inline"
                                size="sm"
                                value={jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "keyword", kwNum], props) ? jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "keyword", kwNum], props) : ""}
                                onChange={(e) => {
                                  let newScripts = { ...props.client_account.scripts };
                                  newScripts[script.name] = newScripts[script.name] || {};
                                  newScripts[script.name]["keyword"] = newScripts[script.name]["keyword"] || {};
                                  newScripts[script.name]["keyword"][kwNum] = e.target.value;
                                  props.setScripts({ ...newScripts });
                                }}
                              />
                            ) : (
                              <Form.Control
                                className="d-inline"
                                size="sm"
                                name={`[scripts][exclude_nb_in_shopping][keyword][${kwNum}]`}
                                value={excludeNbInShoppingKeywords[kwNum]}
                                onChange={(e) => {
                                  let newKeywords = { ...excludeNbInShoppingKeywords };
                                  newKeywords[kwNum] = e.target.value;
                                  setExcludeNbInShoppingKeywords(newKeywords);
                                }}
                              />
                            )}
                            <span className="delete-icon" style={{cursor: "pointer"}} onClick={(e) => deleteKeyword(e, kwNum)}>
                              <i className="fas fa-trash-alt" style={{fontSize: "12px"}}></i>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button className="green-button" onClick={(e) => handleAddKeyword(e)}>Add +</button>
                </div>
              </Col>
            ) : (script.name == "youtube_channel_excluder") ? (
              <Col className="script-box-wide mb-2 px-2">
                <div className="p-3 h-100" style={{ backgroundColor: "#e1e1e1" }}>
                  <div className="mb-2">
                    {props.onboarding ? (
                      <CustomFormCheck
                        id={`scripts_youtube_channel_excluder`}
                        sendUncheckedValue
                        checked={jsDig(["isChecked", script.name, "enabled"], props) == "1" ? true : false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        onChange={(e) => {
                          let newScripts = props.client_account.scripts;
                          newScripts[script.name] = newScripts[script.name] || {};
                          newScripts[script.name]["enabled"] = e.target.checked ? "1" : "0";
                          props.setScripts({ ...newScripts });
                          props.setIsChecked({ ...newScripts });
                          props.checkValidation();
                        }}
                      />
                    ) : (
                      <CustomFormCheck
                        id={`scripts_youtube_channel_excluder`}
                        name={`[scripts][youtube_channel_excluder][enabled]`}
                        sendUncheckedValue
                        defaultChecked={youtubeChannelExcluderData["enabled"] == "1" ? true : false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        static
                      />
                    )}
                  </div>
                  <div>
                    <p className="f14 light-primary nunito-regular pb-3">{script.desc}</p>
                  </div>
                  <div>
                    <p className="f14 light-primary nunito-bold pb-1">Please create a copy of <a href="https://docs.google.com/spreadsheets/d/1kzY39AwTnidat-xzFpcVcs7kPavNXNbjVrm-qPoJPCk" target="_blank" style={{textDecoration: "underline"}}>this</a> google sheet before enabling this script.</p>
                    <p className="f12 light-primary nunito pb-3"><i>Edit access must be granted to support@digitalposition.com</i></p>
                  </div>
                  <div className="d-flex flex-column" style={{gap: "8px"}}>
                    <Form.Group controlId="youtube_channel_excluder_google_sheet" className="mb-0">
                      <Form.Label className="f12 font-weight-bold pb-2 light-primary nunito-regular">Google Sheet</Form.Label>
                      {props.onboarding ? (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          value={jsDig(["client_account", "scripts", "youtube_channel_excluder", "google_sheet"], props) ? jsDig(["client_account", "scripts", "youtube_channel_excluder", "google_sheet"], props) : ""}
                          onChange={(e) => {
                            let newScripts = { ...props.client_account.scripts };
                            newScripts[script.name] = newScripts[script.name] || {};
                            newScripts[script.name]["google_sheet"] = e.target.value;
                            props.setScripts({ ...newScripts });
                            props.setIsChecked({ ...newScripts });
                            props.checkValidation();
                          }}
                          placeholder="https://docs.google.com/spreadsheets/..."
                        />
                      ) : (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="[scripts][youtube_channel_excluder][google_sheet]"
                          value={youtubeChannelExcluderData["google_sheet"] ? youtubeChannelExcluderData["google_sheet"] : ""}
                          onChange={(e) => handleScriptPropertyInput(e, "google_sheet", youtubeChannelExcluderData, setYoutubeChannelExcluderData)}
                          placeholder="https://docs.google.com/spreadsheets/..."
                        />
                      )}
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_allowed_countries" className="mb-0">
                      <Form.Label className="f12 font-weight-bold light-primary nunito-regular">Allowed Countries</Form.Label>
                      <p className="f12 light-primary nunito pb-2"><i>Please supply a regex formula to specfify which countries you would like to whitelist. (E.g. <b>^US|UK|CA$</b>) </i></p>
                      {props.onboarding ? (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          value={jsDig(["client_account", "scripts", "youtube_channel_excluder", "allowed_countries"], props) ? jsDig(["client_account", "scripts", "youtube_channel_excluder", "allowed_countries"], props) : ""}
                          onChange={(e) => {
                            let newScripts = { ...props.client_account.scripts };
                            newScripts[script.name] = newScripts[script.name] || {};
                            newScripts[script.name]["allowed_countries"] = e.target.value;
                            props.setScripts({ ...newScripts });
                            props.setIsChecked({ ...newScripts });
                            props.checkValidation();
                          }}
                          placeholder="^US$"
                        />
                      ) : (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="[scripts][youtube_channel_excluder][allowed_countries]"
                          value={youtubeChannelExcluderData["allowed_countries"] ? youtubeChannelExcluderData["allowed_countries"] : ""}
                          onChange={(e) => handleScriptPropertyInput(e, "allowed_countries", youtubeChannelExcluderData, setYoutubeChannelExcluderData)}
                          placeholder="^US$"
                        />
                      )}
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_impressions_time_range" className="mb-0">
                      <Form.Label className="f12 font-weight-bold light-primary nunito-regular">Impressions Time Range</Form.Label>
                      <p className="f12 light-primary nunito pb-2"><i>Select a predefined time range.</i></p>
                      {props.onboarding ? (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          value={jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_time_range"], props) ? jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_time_range"], props) : "LAST_7_DAYS"}
                          onChange={(e) => {
                            let newScripts = { ...props.client_account.scripts };
                            newScripts[script.name] = newScripts[script.name] || {};
                            newScripts[script.name]["impressions_time_range"] = e.target.value;
                            console.log(newScripts)
                            props.setScripts({ ...newScripts });
                            props.setIsChecked({ ...newScripts });
                            props.checkValidation();
                          }}
                          placeholder="LAST_7_DAYS"
                          as="select"
                        >
                          <option value="LAST_7_DAYS">LAST_7_DAYS</option>
                          <option value="LAST_14_DAYS">LAST_14_DAYS</option>
                          <option value="LAST_30_DAYS">LAST_30_DAYS</option>
                          <option value="LAST_90_DAYS">LAST_90_DAYS</option>
                        </Form.Control>
                      ) : (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="[scripts][youtube_channel_excluder][impressions_time_range]"
                          value={youtubeChannelExcluderData["impressions_time_range"] ? youtubeChannelExcluderData["impressions_time_range"] : "LAST_7_DAYS"}
                          onChange={(e) => handleScriptPropertyInput(e, "impressions_time_range", youtubeChannelExcluderData, setYoutubeChannelExcluderData)}
                          placeholder="LAST_7_DAYS"
                          as="select"
                        >
                          <option value="LAST_7_DAYS">LAST_7_DAYS</option>
                          <option value="LAST_14_DAYS">LAST_14_DAYS</option>
                          <option value="LAST_30_DAYS">LAST_30_DAYS</option>
                          <option value="LAST_90_DAYS">LAST_90_DAYS</option>
                        </Form.Control>
                      )}
                    </Form.Group>
                    <Form.Group controlId="youtube_channel_excluder_impressions_threshold" className="mb-0">
                      <Form.Label className="f12 font-weight-bold light-primary nunito-regular">Impressions Threshold</Form.Label>
                      <p className="f12 light-primary nunito pb-2"><i>Minimum number of impressions to consider a channel for exclusion.</i></p>
                      {props.onboarding ? (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          value={jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_threshold"], props) ? jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_threshold"], props) : ""}
                          onChange={(e) => {
                            let newScripts = { ...props.client_account.scripts };
                            newScripts[script.name] = newScripts[script.name] || {};
                            newScripts[script.name]["impressions_threshold"] = e.target.value;
                            props.setScripts({ ...newScripts });
                            props.setIsChecked({ ...newScripts });
                            props.checkValidation();
                          }}
                          placeholder="Default: 10"
                        />
                      ) : (
                        <Form.Control
                          className="d-inline"
                          size="sm"
                          name="[scripts][youtube_channel_excluder][impressions_threshold]"
                          value={youtubeChannelExcluderData["impressions_threshold"] ? youtubeChannelExcluderData["impressions_threshold"] : ""}
                          onChange={(e) => handleScriptPropertyInput(e, "impressions_threshold", youtubeChannelExcluderData, setYoutubeChannelExcluderData)}
                          placeholder="Default: 10"
                        />
                      )}
                    </Form.Group>
                  </div>
                </div>
              </Col>
            ) : (
              <Col key={script.name} className="script-box mb-2 px-2">
                <div className="p-3 h-100" style={{ backgroundColor: "#e1e1e1" }}>
                  <div className="mb-2">
                    {props.onboarding ? (
                      <CustomFormCheck
                        id={`scripts_${script.name}`}
                        sendUncheckedValue
                        checked={props.isChecked[script.name] == "1" ? true : false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        onChange={(e) => {
                          let newScripts = props.client_account.scripts;
                          newScripts[script.name] = e.target.checked ? "1" : "0";
                          props.setScripts({ ...newScripts });
                          props.setIsChecked({ ...newScripts });
                          props.checkValidation();
                        }}
                      />
                    ) : (
                      <CustomFormCheck
                        id={`scripts_${script.name}`}
                        name={`[scripts][${script.name}]`}
                        sendUncheckedValue
                        defaultChecked={props.client_account.scripts[script.name] == "1" ? true : false}
                        label={`<p className="f16 primary nunito-regular">${script.title}</p>`}
                        static
                      />
                    )}
                  </div>
                  <div>
                    <p className="f14 light-primary nunito-regular">{script.desc}</p>
                  </div>
                </div>
              </Col>
            )}
          </React.Fragment>
        );
      })}
    </>
  )
}
